import { Box, Button, Typography } from '@mui/material';
import { Map } from '@opengov/compose-app/immutable';
import React from 'react';

import { IPublicationViewMessages } from '../../../../../types';
import { styles } from '../../../StoryList/SelectionToolbar/SelectionToolbar.styles';

export type IReportSelectionToolbarProps = {
  messages: IPublicationViewMessages;
  selectedItems: any;
  setSelectedItems(arg0: any): void;
  openBulkUpdateModal(): void;
  openBulkReportDeleteModal(): void;
};

export const ReportSelectionToolbar = (props: IReportSelectionToolbarProps) => {
  const { messages, selectedItems, setSelectedItems, openBulkUpdateModal, openBulkReportDeleteModal } = props;
  if (selectedItems.size === 0) return null;
  const text =
    selectedItems.size === 1
      ? messages.reportSelected({ value: selectedItems.size })
      : messages.reportsSelected({ value: selectedItems.size });
  return (
    <Box sx={styles.selectControls} data-test="reports-selection-toolbar">
      <section aria-label="Report selection">
        <Typography component="span" sx={styles.groupLabel}>{messages.manageReports}</Typography>
        <Box sx={styles.toolbarSelectionInfo}>
          <Typography variant="body2" fontWeight={500} data-test="reports-selected-text">
            {text}
          </Typography>
          <Box sx={styles.divider} />
          <Box
            component="button"
            tabIndex={0}
            data-test="unselect-stories-button"
            sx={styles.unselectButton}
            onClick={() => setSelectedItems(Map([]))}
          >
            {messages.clearSelection}
          </Box>
        </Box>
      </section>
      <Box sx={styles.buttons}>
        <Button variant="outlined" color="secondary" size="small" data-test="move-stories-button" onClick={openBulkUpdateModal}>
          {messages.editDataUpdateFrequency}
        </Button>
        <Button variant="contained" color="error" size="small" data-test="delete-stories-button" onClick={openBulkReportDeleteModal}>
          {messages.delete}
        </Button>
      </Box>
    </Box>
  );
};
